// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","close":"_35avxD5eUR1V","header":"_2XrDvNQw4X5P","header__wrapper":"_3HF5jNNgdPUS","title":"_2XFsJIl8eLuB","info":"_2TCgS_t7bOH9"};